import React from 'react';
import { Paper, Divider, CircularProgress, IconButton, FontIcon } from 'material-ui';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import StatusNode from './left-nav-status';
import UpdateAssignee from '../../generic-components/update-assignee';
import UpdatePriority from '../../dummy-account/update-rate-conversion-priority';
import supplierWizardCompleteImage from '../../../../../www/images/supplier-wizard-complete.svg';
import LeftNavWidget from '../../generic-components/left-nav-widget';
import ErrorCheckIcon from '../draftNTemplate-container/error-check-indicator-icon';
import ProductsNode from './products/left-nav-products';
import R from 'ramda';
import PartnerNode from '../contract-policies/partner-node';
import { getPriorityColor, getPriorityIcon } from '../../contractingUtils';
import moment from 'moment';

const AssigneeLabelButton = ({ assigneeLabel, onClick }) => (
<div className="flex-tc-sb" onClick={onClick} style={{ borderBottom: '1px solid #d9d9d9', height: '48px', paddingLeft: '16px' }}>
  <div className="flex-center" style={{ width: '80%' }}>
    <FontIcon className="tc-icon-person" style={{ color: 'rgba(0, 0, 0, 0.54)' }}/> &nbsp;&nbsp;
    <div style={{ width: '80%', overflowX: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
      {assigneeLabel}
    </div>
  </div>
  <IconButton onClick={onClick}>
    <FontIcon className="tc-icon-arrow-drop-down" />
  </IconButton>
</div>);
const PriorityLabelButton = ({ priority, onClick }) => (
<div className="flex-tc-sb" onClick={onClick} style={{ borderBottom: '1px solid #d9d9d9', height: '48px', paddingLeft: '16px' }}>
  <div className="flex-center" style={{ width: '80%' }}>
    {getPriorityIcon(priority)} &nbsp;&nbsp;
    <div style={{ width: '80%', overflowX: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', color: getPriorityColor(priority) }}>
      {priority}
    </div>
  </div>
  <IconButton onClick={onClick}>
    <FontIcon className="tc-icon-arrow-drop-down" />
  </IconButton>
</div>);
const ContractDetailsLeftNav = ({
  goToDashboard,
  changeLeftNavRoute,
  changeContractStateTo,
  openAddEditContractDialog,
  sortingProducts,
  location,
  leftNav,
  companyType,
  appBarBgColor,
  textColor,
  headerStyle,
  leftNavTitle,
  leftNavLoading,
  draftErrors,
  toggleDraftErrorsDialog,
  isDummyAccount,
  pureDocView,
  companyName,
}) => {
  const { collection, locationId, contractId } = leftNav;
  const isRequest = !locationId && !leftNav.buyerChecked;
  const isRequestForBuyer = isRequest && companyType === 'Contractor';
  const isRequestForSupplier = isRequest && companyType === 'Supplier';
  const externallyReceived = !locationId && leftNav.buyerChecked;
  const isExternallyReceivedForBuyer = externallyReceived && companyType === 'Contractor';
  const isExternallyReceivedForSupplier = externallyReceived && companyType === 'Supplier';
  return (
    <div
      style={{ width: '22%', backgroundColor: '#f4f6fa', borderRight: '1px solid #e0e0e0' }}
    >
      <div className="flex-tc-sb" style={{ backgroundColor: appBarBgColor, height: '48px', color: '#fff', justifyContent: 'initial', ...headerStyle }}>
        {
          Boolean(!isDummyAccount && !pureDocView) && (
            <IconButton
              iconClassName="tc-icon-arrow_back"
              iconStyle={{ color: textColor || '#fff' }}
              onClick={goToDashboard}
            />
          )
        }
        <div style={{ fontSize: '20px', marginLeft: '8px' }}>{isDummyAccount || pureDocView ? 'Rate Sheet' : leftNavTitle}</div>
      </div>
      {
        R.call(R.cond([
          [() => collection === 'draft' && !draftErrors.errorExist, R.always(<div className="flex-tc-sb" style={{ width: '100%', textAlign: 'center', height: '32px', lineHeight: '32px', borderBottom: '1px solid #e0e0e0', padding: '0 8px' }}>
            <img src={supplierWizardCompleteImage} style={{ width: '24px', marginRight: '4px' }}/>
            <span> Information Is Complete</span>
            <img src={supplierWizardCompleteImage} style={{ width: '24px', marginLeft: '4px' }} />
          </div>)],
          [() => collection === 'draft' && draftErrors.errorExist, R.always(<div style={{ width: '100%', height: '36px', position: 'relative', backgroundColor: '#9e9e9e' }}>
            <div style={{ height: '36px', backgroundColor: '#4caf50', width: `${draftErrors.percent}%` }}/>
            <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', lineHeight: '36px', textAlign: 'center', color: 'white' }}>
            <span>
              {draftErrors.percent}% completed<small onClick={toggleDraftErrorsDialog} style={{ cursor: 'pointer', paddingLeft: '8px', textDecoration: 'underline' }}>What's missing?</small>
            </span>
            </div>
          </div>)],
          [R.T, R.always('')],
        ]))
      }
      {
        !Boolean(isExternallyReceivedForBuyer || isRequestForBuyer) && (
          <StatusNode
            changeContractStateTo={changeContractStateTo}
            companyType={companyType}
            files={leftNav.files}
            {
              ...R.pick([
                'contractState',
                'contractId',
                'supplierChecked',
                'locationId',
                'originFrom',
                'buyerChecked',
                'buyerDownloaded',
              ], leftNav)
            }
          />
        )
      }
      {
        companyType === 'Contractor' && Boolean(locationId) && (
          <div
            style={{
              borderBottom: '1px solid #d9d9d9',
            }}
          >
            <Paper
              style={{
                width: '90%',
                fontSize: '12px',
                margin: '12px auto',
                padding: '12px',
                border: '1px solid #e0e0e0',
                borderRadius: '5px',
              }}
            >
              <div>
                {leftNav.templateFromDummy ? `Creator: ${companyName}` : `Creator: ${R.path(['left', 'from', 'name'], leftNav) || 'Supplier'}`}
              </div>
              {
                Boolean(leftNav.rateContainer && leftNav.rateContainer.id) && (
                    <span>
                      This contract belongs to the <Link to={`/contracting/workspace/${leftNav.rateContainer.id}/documents`}>{leftNav.rateContainer.partnerName} {leftNav.rateContainer.year} contracting workspace</Link>.
                    </span>
                  )
              }
            </Paper>
          </div>
        )
      }
      {
        companyType === 'Contractor' && !locationId && (
          <UpdateAssignee
            isContainer={!Boolean(leftNav.locationId)}
            assignee={leftNav.assignee}
            contractId={leftNav.contractId}
            files={leftNav.files}
            Button={AssigneeLabelButton}
          />
        )
      }
      {
        Boolean(companyType === 'Contractor'
          && (
            (leftNav.assignee && leftNav.assignee.userId === 'dl@tourconnect.com')
            || leftNav.rateConversionStatus !== 'Awaiting Supplier Rates'
          )
        ) && (
          <UpdatePriority
            priority={leftNav.priority}
            contractId={leftNav.contractId}
            button={<PriorityLabelButton priority={leftNav.priority} />}
          />
        )
      }
      {
        Boolean(companyType === 'Contractor' && leftNav.signatures && leftNav.signatures.length) && (
          <Paper
            style={{
              width: '90%',
              fontSize: '12px',
              margin: '12px auto',
              padding: '12px',
              border: '1px solid #e0e0e0',
              borderRadius: '5px',
            }}
          >
            <div style={{ width: '100%', whiteSpace: 'nowrap', overflowX: 'hidden', textOverflow: 'ellipsis' }}>
              Signature: {leftNav.signatures[0].signatureText}
            </div>
            <div style={{ width: '100%', whiteSpace: 'nowrap', overflowX: 'hidden', textOverflow: 'ellipsis' }}>
              Signed by: {leftNav.signatures[0].signedBy}
            </div>
            <small>{moment(leftNav.signatures[0].signedAt).format('l')}</small>
          </Paper>
        )
      }
      {
        R.call(R.cond([
          [() => isRequestForBuyer || isExternallyReceivedForBuyer, R.always(
            <LeftNavWidget
              routeName={`/contracting/${collection}/${contractId}/policies`}
              name="WORKSPACE"
              location={location}
              onTouchTap={() => changeLeftNavRoute(`/contracting/${collection}/${contractId}/policies`)}
            />
          )],
          [() => isRequestForSupplier, R.always(
            <LeftNavWidget
              routeName={`/contracting/${collection}/${contractId}/policies`}
              name="Send Rates"
              location={location}
              onTouchTap={() => changeLeftNavRoute(`/contracting/supplier-wizard/${contractId}`)}
            />
          )],
          [() => isExternallyReceivedForSupplier, R.always(
            <LeftNavWidget
              routeName={`/contracting/${collection}/${contractId}/policies`}
              name="Notes"
              location={location}
              onTouchTap={() => changeLeftNavRoute(`/contracting/${collection}/${contractId}/policies`)}
            />
          )],
          [R.T, R.always(
            <LeftNavWidget
              style={{ margin: '3px 0 4px' }}
              routeName={`/contracting/${collection}/${contractId}/policies`}
              name={
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {
                    leftNav.state === 'draft' && (<ErrorCheckIcon showError={draftErrors.locationPercent !== 100} />)
                  } &nbsp;
                  Policies & Notes
                </div>
              }
              location={location}
              onTouchTap={() => changeLeftNavRoute(`/contracting/${collection}/${contractId}/policies`)}
            />
          )],
        ]))
      }
      <Divider />
      {
        Boolean(isRequestForBuyer || isExternallyReceivedForBuyer) && (
          <Paper
            style={{
              width: '90%',
              margin: '12px auto',
              padding: '24px',
              border: '1px solid #e0e0e0',
              borderRadius: '5px',
            }}
          >
            <PartnerNode
              forLeftNav
              isReceiver
              forSupplier
              partners={leftNav.partners}
              contacts={leftNav.contacts}
            />
          </Paper>
        )
      }
      {
        Boolean(leftNav.collection) && (
          <ProductsNode
            location={location}
            changeLeftNavRoute={changeLeftNavRoute}
            sortingProducts={sortingProducts}
            openAddEditContractDialog={openAddEditContractDialog}
            {
            ...R.pick([
              'contractState',
              'contractId',
              'locationId',
              'collection',
              'supplierEditable',
              'companyName',
              'allContractingReadyProducts',
              'productsArray',
            ], leftNav)
            }
          />
        )
      }
      {
        leftNavLoading && (
          <div style={{ margin: '16px 0', textAlign: 'center' }}>
            <CircularProgress/>
          </div>
        )
      }
    </div>
  );
};

const mapStateToProps = state => {
  const { user, contracting } = state;
  const leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  const companyType = user.getIn(['user', 'type']);
  return ({
    companyType,
    leftNav,
    leftNavLoading: contracting.contractActivitiesProducts.get('leftNavLoading'),
    draftErrors: contracting.contractActivitiesProducts.get('draftErrors').toJS(),
    isDummyAccount: user.get('isDummyAccount'),
    pureDocView: user.get('pureDocView'),
    companyName: user.getIn(['company', 'companyName']),
  });
};
export default connect(mapStateToProps)(ContractDetailsLeftNav);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/left-nav/left-nav.jsx